import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { usePermission } from '@fs/zion-permissions'
import getProfileView from './getProfileView'
import useProfile from './useProfile'

export default function useProfileView() {
  const { profile, profileLoading, handleChangeProfile } = useProfile()
  const [canSetPublic] = usePermission('DiscloseUserProfile', 'UserProfile')
  const { t } = useTranslation()
  const returnProps = useMemo(() => {
    const profileView = getProfileView({ profile, canSetPublic, t })
    // can remove this line once all components are using the new profileView
    profileView.profile = profile
    const handleChangeProfileView = (profileViewItem, formValues) => {
      const profileChange = profileViewItem.asProfileItem(formValues)
      return handleChangeProfile(profileChange)
    }
    return {
      profileView,
      profileViewLoading: profileLoading,
      handleChangeProfileView,
    }
  }, [canSetPublic, profile, profileLoading, handleChangeProfile, t])
  return returnProps
}
